import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submenu-list',
  templateUrl: './submenu-list.component.html',
  styleUrls: ['./submenu-list.component.css']
})
export class SubmenuListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
